// extracted by mini-css-extract-plugin
export default {"message":"Messages-message-Xvm"};